<script lang="ts" setup>
  import { type PropType, computed } from 'vue';
  import { useRoute } from '@othercommerce/foundation';
  import type { Country, CustomerBillingAddress } from '@storefront/types';
  import type { Dictionary } from '@othercommerce/domain';
  import { StoreLayout, AccountLayout } from '@storefront/components';

  const props = defineProps({
    countries: { type: Array as PropType<Country[]>, required: true },
    isMedicalProvider: { type: Boolean, default: false },
    addressType: { type: Array as PropType<Dictionary>, required: true },
    address: { type: Object as PropType<CustomerBillingAddress>, required: true },
    regions: { type: Object as PropType<Dictionary>, required: true },
  });

  defineOptions({
    layout: [StoreLayout, AccountLayout],
    inheritAttrs: false,
  });

  const route = useRoute();

  const action = computed(() =>
    props.address.meta.exists
      ? route('web.account.address.billing.update', { billing: props.address.id })
      : route('web.account.address.billing.store'),
  );

  const method = computed(() =>
    props.address.meta.exists ? 'PATCH' : 'POST',
  );
</script>
<template>
  <UiModal medium open visitable>
    <FormController v-slot="{ data, submit, processing }" :action="action" :data="address" :method="method" class="billing-address-form">
      <header>
        <slot name="header">
          <h2 v-if="data.id" class="billing-address-form__heading">
            {{ $t('SHOP.ACCOUNT.HEADER.BILLING_ADDRESS_EDIT') }}
          </h2>
          <h2 v-else class="billing-address-form__heading">
            {{ $t('SHOP.ACCOUNT.HEADER.BILLING_ADDRESS_CREATE') }}
          </h2>
        </slot>
      </header>
      <SfBillingAddressForm :addressType :countries :data :regions />
      <UiButtonGroup end>
        <SfButton :href="$route('web.account.address.billing.index')">
          {{ $t('SHOP.ACTION.CANCEL') }}
        </SfButton>
        <SfButton :loading="processing" primary type="submit" @click="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </UiButtonGroup>
    </FormController>
  </UiModal>

  <RouterView />
</template>
